// extracted by mini-css-extract-plugin
export default {"dealerLogoContainer":"dealer-logo__dealerLogoContainer___19-Ng","dealerLogo":"dealer-logo__dealerLogo___HFWTV"};